/* eslint-disable class-methods-use-this */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import VerticalCarousel from 'yoda-site-components/lib/components/Carousel/VerticalCarousel';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames/bind';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Play from 'yoda-core-components/lib/assets/svg/Video.svg';
import InlineImageLoaderAction from 'yoda-site-components/lib/actions/InlineImageLoaderAction';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import {
    selectFilmstripImagesAndVideo,
    getSelectedProductVideos,
} from 'yoda-site-components/lib/selectors/ProductImageSelector';
import { selectMarketPlaceSellerInfo } from 'yoda-site-components/lib/selectors/MarketPlaceSelector';
import {
    selectFeatureFlags,
    selectPreferences,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import UrgencyMessagingConnected from '../UrgencyMessaging/UrgencyMessaging';
import * as styles from './SlickCarouselLarge.css';
import InlineVideo from '../InlineVideo/InlineVideo';
import { selectPageLoaded } from '../../selectors/selectLazy';
import InnerImageZoom from '../InlineZoomViewer/InnerImageZoom';

const cx = classNames.bind(styles);

const slidesToShow = 5;

/* istanbul ignore next */
export class SlickCarousel extends Component {
    static defaultProps = {
        carouselData: {},
        deviceType: {},
        filmStripImagesAndVideos: [],
        productVideos: [],
        rewindOnChange: true,
        slideCallback: null,
        actions: {},
        pageLoaded: false,
        isInlineImageLoading: false,
        featureFlags: {},
        isBundle: false,
        preferences: {},
        isMarketPlaceProduct: false,
        enableMarketPlace: false,
    };

    static propTypes = {
        carouselItemRenderer: PropTypes.func.isRequired,
        carouselData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        deviceType: PropTypes.oneOfType([PropTypes.object]),
        filmStripImagesAndVideos: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productVideos: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        slideCallback: PropTypes.func,
        rewindOnChange: PropTypes.bool,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        pageLoaded: PropTypes.bool,
        isInlineImageLoading: PropTypes.bool,
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        isBundle: PropTypes.bool,
        preferences: PropTypes.oneOfType([PropTypes.object]),
        isMarketPlaceProduct: PropTypes.bool,
        enableMarketPlace: PropTypes.bool,
    };

    constructor() {
        super();
        this.state = {
            currentSlideIndex: 0,
            currentVideoLabelSelected: null,
            hoveredImage: null,
        };
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.enableZoomViewer = debounce(this.enableZoomViewer, 100);
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { rewindOnChange, carouselData } = this.props;
        if (rewindOnChange && nextProps.carouselData !== carouselData) {
            this.slide(0);
            this.selectImage(0);
        }

        if (
            JSON.stringify(this.props.carouselData) !== JSON.stringify(nextProps.carouselData) &&
            this.state.hoveredImage
        ) {
            this.setState({
                hoveredImage: null,
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            !isEqual(nextState.currentSlideIndex, this.state.currentSlideIndex) ||
            !isEqual(nextState.hoveredImage, this.state.hoveredImage) ||
            !isEqual(
                JSON.stringify(nextProps.carouselData),
                JSON.stringify(this.props.carouselData)
            )
        );
    }

    getFilmStripData = () => {
        if (__SERVER__) {
            return this.props.filmStripImagesAndVideos.slice(0, slidesToShow);
        }
        return this.props.filmStripImagesAndVideos;
    };

    slide = (idx) => {
        this.verticalSlider && this.verticalSlider.slickGoTo(idx);
    };

    selectImage = (idx, evt) => {
        evt && evt.preventDefault && evt.preventDefault();
        if (idx !== this.state.currentSlideIndex) {
            this.setState({ currentSlideIndex: idx });
            if (get(evt, 'target.id', '') !== this.state.currentVideoLabelSelected) {
                this.setState({ currentVideoLabelSelected: null });
            }
            this.props.slideCallback && this.props.slideCallback(idx);
        }
    };

    // eslint-disable-next-line react/sort-comp
    cancelDefaultHref(evt) {
        evt && evt.preventDefault && evt.preventDefault();
    }

    next = () => {
        this.verticalSlider.slickNext();
    };

    previous = () => {
        this.verticalSlider.slickPrev();
    };

    itemRenderer = (...args) => {
        const { featureFlags: { enableVideoPlacementChange = false } = {} } = this.props;
        const idx = args[1];
        let url = '#img';
        let target = '';
        let onClickHandler =
            args.length > 1 && this.state.currentSlideIndex !== idx
                ? this.selectImage.bind(this, idx)
                : this.cancelDefaultHref;
        if (args && args[0].isVideo && args[0].type !== 'Scene7') {
            url = args[0].url;
            target = '_blank';
            onClickHandler = null;
        }
        const returnItem =
            this.props.isBundle ||
            (enableVideoPlacementChange
                ? args[0]
                : !args[0].isVideo || (!true && args[0].isVideo)) ? (
                <a
                    href={url}
                    className={cx('slide', {
                        'slide--active': this.state.currentSlideIndex === idx,
                        'slide--selected': !args[0].isVideo && this.state.currentSlideIndex === idx,
                    })}
                    onClick={onClickHandler}
                    target={target}
                    rel="noopener noreferrer"
                >
                    {this.props.carouselItemRenderer.apply(null, args)}
                </a>
            ) : null;
        return returnItem;
    };

    enableZoomViewer = () => {
        const { pageLoaded, isInlineImageLoading, actions, carouselData } = this.props;
        const { currentSlideIndex } = this.state;
        if (pageLoaded) {
            this.setState({
                hoveredImage: carouselData[currentSlideIndex],
            });

            if (!isInlineImageLoading) {
                actions.showInlineImageLoader();
            }
        }
    };

    removeImageLoader = () => {
        const { isInlineImageLoading, actions } = this.props;

        if (isInlineImageLoading) {
            actions.removeInlineImageLoader();
        }

        return null;
    };

    videoLabelClickHandler = (e) => {
        e && e.preventDefault && e.preventDefault();
        const targetID = get(e, 'currentTarget.id', '');
        let idx = 0;
        this.props.filmStripImagesAndVideos.forEach((item, index) => {
            if (item.id === targetID) {
                idx = index;
            }
        });
        this.selectImage(idx, e);
        this.setState({ currentVideoLabelSelected: targetID });
    };

    render() {
        const { carouselData, featureFlags } = this.props;
        const { enableVideoPlacementChange = false } = featureFlags;
        const filmStripData = enableVideoPlacementChange ? carouselData : this.getFilmStripData();
        const { currentSlideIndex, hoveredImage } = this.state;
        const { isBundle } = this.props;

        const selectedProductImage = enableVideoPlacementChange
            ? filmStripData[currentSlideIndex]
            : carouselData[currentSlideIndex];

        const ZoomSrc = selectedProductImage.key.replace(/=550/g, '=1500');
        const productVideoLabels = this.props.productVideos.map((video) => (
            <div className={`${cx('videoLabelContainer')} ${dt(['mt-4'])}`}>
                <a
                    id={video.id}
                    href={video.url}
                    className={cx('videoLabelAnchor')}
                    onClick={this.videoLabelClickHandler}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div className={cx('videoIcon')}>
                        <Icon
                            iconType="svg"
                            pathClassName={cx('iconPath')}
                            className={`${cx('svg-icon')} ${dt([
                                this.state.currentVideoLabelSelected === video.id
                                    ? 'opacity-100'
                                    : 'opacity-50',
                            ])}`}
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                        >
                            <Play />
                        </Icon>
                    </div>
                    <div
                        className={cx('videoLabel', 'labelTxt', {
                            labelTxtBold: this.state.currentVideoLabelSelected === video.id,
                        })}
                    >
                        {video.label ? video.label : 'Product Video'}
                    </div>
                </a>
            </div>
        ));
        return (
            <div
                className={`${cx('sm12', 'md12', 'lg12', 'xl12')} ${dt(['sm:!px-0', 'sm:!flex'])}`}
            >
                <div
                    className={`${cx(
                        'verticalThumbContainer',
                        'lg2',
                        'xl2',
                        'md2',
                        'sm2',
                        'row'
                    )} ${dt(['sm:!px-0', 'max-w-[101px]', 'mr-4'])}`}
                >
                    <ErrorBoundary>
                        <VerticalCarousel
                            ref={(c) => {
                                this.verticalSlider = c;
                            }}
                            theme="verticalCarousel"
                            direction="vertical"
                            automationId="grid-nucleus-carousel"
                        >
                            {filmStripData.map(this.itemRenderer)}
                        </VerticalCarousel>
                    </ErrorBoundary>
                </div>
                <div
                    className={`${cx(
                        'lgProdImgContainer',
                        'lg10',
                        'xl10',
                        'md10',
                        'sm10',
                        'row',
                        'noPad'
                    )} ${dt(['pb-[100%]', 'h-full', 'sm:!px-0', 'sm:!w-full'])}`}
                >
                    <div
                        className={`${cx('lgProdImgWrap')} ${dt([
                            'absolute',
                            'top-0',
                            'left-0',
                            'bottom-0',
                            'right-0',
                            'w-full',
                            'h-full',
                        ])}`}
                    >
                        {/* Add zoom component here */}
                        {!selectedProductImage?.isVideo &&
                            get(featureFlags, 'enableZoomViewer', true) && (
                                <InnerImageZoom
                                    deviceType={this.props.deviceType}
                                    src={selectedProductImage.key}
                                    zoomSrc={ZoomSrc}
                                />
                            )}
                        {selectedProductImage.isVideo && (
                            <ErrorBoundary>
                                <InlineVideo
                                    videos={selectedProductImage}
                                    dataAutomationId="product-videos"
                                    key={currentSlideIndex}
                                    initCallBack={this.removeImageLoader}
                                    enableVideoPlacementChange={enableVideoPlacementChange}
                                    isMarketPlaceProduct={this.props.isMarketPlaceProduct}
                                    enableMarketPlace={this.props.enableMarketPlace}
                                />
                            </ErrorBoundary>
                        )}
                    </div>
                    <ErrorBoundary>
                        {get(featureFlags, 'urgencyMessagingEnabled', true) ? (
                            <span
                                data-automation-id="urgency-icon"
                                className={`${cx('UrgencyMessaging')} ${dt([
                                    'relative',
                                    'flex',
                                    'w-full',
                                ])}`}
                            >
                                <span className={dt(['absolute', '-translate-x-1/2', 'left-1/2'])}>
                                    <UrgencyMessagingConnected />
                                </span>
                            </span>
                        ) : null}
                    </ErrorBoundary>

                    {!enableVideoPlacementChange && (
                        <div className={cx('videoLabelsContainer')}>
                            {isBundle ? null : productVideoLabels}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const marketPlaceSellerInfo = selectMarketPlaceSellerInfo(false)(state);
    const featureFlags = selectFeatureFlags(state);
    return {
        pageLoaded: selectPageLoaded(state),
        filmStripImagesAndVideos: selectFilmstripImagesAndVideo(false)(state),
        productVideos: getSelectedProductVideos(false)(state),
        isInlineImageLoading: state.isInlineImageLoading,
        featureFlags,
        preferences: selectPreferences(state),
        isMarketPlaceProduct: get(marketPlaceSellerInfo, 'isMarketPlaceProduct', false),
        enableMarketPlace: get(featureFlags, 'enableMarketPlace', false),
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(InlineImageLoaderAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SlickCarousel);
